import { definePluginClient } from "../../client/builder";
import type { storesPlugin } from "./server";

export const storesPluginClient = definePluginClient<typeof storesPlugin>("stores");
